<template>
    <div>
        <!-- Лого sim delivery -->
        <div class="text-white font-bold text-2xl lg:text-4xl" style="background: rgb(78, 115, 223);">
            <a href="https://simdelivery.ru/" target="_blank">
                <div class="p-2">
                    <img :src="require('@/assets/logo.png')" class="h-12 md:h-16 mx-auto" alt="">
                </div>
            </a>
        </div>

        <!-- Состояние загрузки -->
        <div v-if="loadingData" class="max-w-3xl mx-auto mt-12 text-center">
            <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-3"></div>
            <p class="text-gray-600">Загрузка данных курьера...</p>
        </div>

        <!-- Карточка курьера -->
        <div v-else class="max-w-3xl mx-auto mt-8 bg-white rounded-lg shadow-md p-6">
            <div class="flex flex-col items-center gap-4 mb-6 sm:flex-row sm:items-start sm:gap-6">
                <!-- Фото курьера -->
                <div class="w-56 h-64 flex-shrink-0 rounded-md overflow-hidden border-2 border-gray-200 bg-gray-50">
                    <img :src="courier.photo" alt="Фото курьера" class="w-full h-full object-cover"/>
                </div>
                <!-- ФИО курьера -->
                <div class="text-center sm:text-left sm:flex-1 sm:min-w-0">
                    <h2 class="text-2xl sm:text-4xl font-bold text-gray-800 break-words">
                        {{ courier.fullName }}
                    </h2>
                    <p class="text-gray-600 text-lg sm:text-2xl">Курьер службы доставки SimDelivery</p>
                </div>
            </div>

            <!-- Блок с документами -->
            <div class="mt-6 border-t pt-4">
                <h3 class="text-lg font-semibold text-gray-700 mb-3">Документы:</h3>
                <div class="flex flex-wrap gap-3">
                    <div
                        v-for="(doc, index) in courier.documents"
                        :key="index"
                        class="cursor-pointer bg-blue-50 hover:bg-blue-100 rounded-md px-4 py-2 transition-colors"
                        @click="openPdfModal(doc)"
                    >
                        <div class="flex items-center">
                            <div class="flex-shrink-0 text-blue-500 mr-2 h-6 w-6 ">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                    />
                                </svg>
                            </div>
                            <span class="text-blue-600 font-medium">{{ doc.name }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Модальное окно для PDF -->
        <div
            v-if="showModal"
            class="fixed inset-0 z-50 overflow-y-auto bg-black bg-opacity-50 flex items-center justify-center p-4"
        >
            <div
                class="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col"
                style="min-width: 300px;"
            >
                <!-- Шапка модального окна -->
                <div class="flex justify-between items-center border-b p-4">
                    <h3 class="text-lg font-semibold truncate max-w-[80%]">
                        {{ currentDocument.name }}
                    </h3>
                    <button @click="closePdfModal" class="text-gray-500 hover:text-gray-700">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>
                <!-- Контент PDF -->
                <div class="flex-1 overflow-auto p-4">
                    <pdf :src="currentDocument.link" class="w-full" style="height: 70vh"/>
                </div>
                <!-- Футер модального окна -->
                <div class="border-t p-4 flex flex-col sm:flex-row justify-between gap-3 sm:gap-0">
                    <button
                        @click="downloadPdf"
                        class="flex items-center justify-center px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 transition-colors"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5 mr-1"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                            />
                        </svg>
                        Скачать
                    </button>
                    <button
                        @click="closePdfModal"
                        class="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
                    >
                        Закрыть
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import pdf from "vue-pdf";
import axios from "axios";

export default {
    components: {pdf},
    data() {
        return {
            token: null,
            courier: {
                photo: "",
                fullName: "",
                documents: [],
            },
            loadingData: true,
            showModal: false,
            currentDocument: null,
        };
    },
    mounted() {
        this.extractTokenFromUrl();
        if (this.token) {
            this.fetchCourierData();
        } else {
            this.redirectToNotFound();
        }
    },
    methods: {
        extractTokenFromUrl() {
            const urlParams = new URLSearchParams(window.location.search);
            this.token = urlParams.get("t");
        },
        redirectToNotFound() {
            window.location.href = "https://sim-delivery.ru/r?q=not_found";
        },
        async fetchCourierData() {
            try {
                const apiUrl = `https://sim-delivery.ru/r/getCourierCardData?token=${this.token}`;
                const response = await axios.get(apiUrl);

                if (response.data) {
                    this.courier = {
                        fullName: response.data.name,
                        photo: response.data.photo,
                        documents: response.data.docs.map((doc) => ({
                            name: doc.name,
                            link: doc.url,
                        })),
                    };
                } else {
                    throw new Error("Неверный формат ответа сервера");
                }
            } catch (error) {
                if (error.response && [404].includes(error.response.status)) {
                    this.redirectToNotFound();
                } else {
                    this.redirectToNotFound();
                }
            } finally {
                this.loadingData = false;
            }
        },
        openPdfModal(document) {
            this.currentDocument = document;
            this.showModal = true;
        },
        closePdfModal() {
            this.showModal = false;
            this.currentDocument = null;
        },
        downloadPdf() {
            if (this.currentDocument?.link) {
                const link = document.createElement("a");
                link.href = this.currentDocument.link;
                link.target = "_blank";
                link.download = this.currentDocument.name + ".pdf";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        },
    },
};
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.3s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;
}

.animate-spin {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
